<template>
    <div class="progress-bar"
        :style="{ height: `${customHeight}rem` }"
    >
        <div :class="['progress-bar__value', {'progress-bar__value--dark' : dark}]"
            :style="{
                width: `${computedPercentageForWidth}%`,
                backgroundColor: progressBarColor,
            }"
        />
        <span v-if="showNumber"
            class="progress-bar__text"
        >
            {{ percentageText }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        percentage: {
            type: Number,
            default: 0,
        },
        showNumber: {
            type: Boolean,
            default: true,
        },
        longText: {
            type: Boolean,
            default: true,
        },
        customHeight: {
            type: Number,
            default: 0.4,
        },
        dark: {
            type: Boolean,
            default: false,
        },
        progressBarColor: {
            type: String,
            default: '',
        },
    },
    computed: {
        computedPercentageForWidth() {
            return Math.max(0, Math.min(100, this.percentage));
        },

        computedPercentageForText() {
            return Math.max(0, Math.min(100, Math.floor(this.percentage * 100) / 100));
        },

        percentageText() {
            return this.longText ? `${this.computedPercentageForText}% ${this.$t('profile.progressComplete')}` : `${this.computedPercentageForText}%`;
        },
    },
};
</script>

<style lang="scss" scoped>
    .progress-bar {
        background: rgba($cyprus-color, 0.15);
        border-radius: 1rem;
        width: 100%;

        &__value {
            background: $lima-color;
            height: 100%;
            border-radius: 1rem;

            &--dark {
                background-color: $japanese-laurel;
            }
        }

        &__text {
            font-size: 1.2rem;
            line-height: 1.8rem;
            font-weight: 400;
            color: $cyprus-color;
        }
    }
</style>